import { getStore } from '@/utils/dva'
import { storage } from '@/hooks/useIknow'

// 读取
const read = key => {
    try {
        const res = localStorage.getItem(key)

        const parsedRes = JSON.parse(res)

        return parsedRes || {}
    } catch (e) {
        console.error('catchError', e)
    }

    return {}
}

// 设置
const set = (key, value) => {
    try {
        const str = JSON.stringify(value)

        localStorage.setItem(key, str)
    } catch (e) {
        console.error('catchError', e)
    }
}

export const saveDataByUid = (key, value) => {
    if (typeof getStore()?.getState !== 'function') {
        return
    }

    const uid = getStore()?.getState()?.user?.currentUser?.uid
    const cacheKey = `rec_${uid}`

    if (uid) {
        const cached = read(cacheKey)

        cached[key] = value

        set(cacheKey, cached)
    }
}

export const getDataByUid = key => {
    if (typeof getStore()?.getState !== 'function') {
        return null
    }

    const uid = getStore()?.getState()?.user?.currentUser?.uid
    const cacheKey = `rec_${uid}`

    if (uid) {
        const cached = read(cacheKey)

        return cached[key]
    }

    return null
}

const removeDataByUid = key => {
    const uid = getStore()?.getState()?.user?.currentUser?.uid
    const cacheKey = `rec_${uid}`

    if (uid) {
        const cached = read(cacheKey) || {}

        if (cached?.hasOwnProperty?.(key)) {
            delete cached[key]

            set(cacheKey, cached)
        }
    }
}

export const localUserStorage = {
    get: getDataByUid,
    set: saveDataByUid,
    remove: removeDataByUid,
}

// 记录用户的具体数据
export const setStotageUserData = (storageNameKey, value) => {
    const uid = getStore()?.getState()?.user?.currentUser?.uid

    let valueArr = storage.get(storageNameKey) || []
    let itemUidObj = valueArr.find(item => item.uid === uid)
    if (itemUidObj) {
        valueArr.forEach(item => {
            if (item.uid === uid) {
                item.value = value
            }
        })
    } else {
        valueArr.push({
            uid,
            value,
        })
    }
    storage.set(storageNameKey, valueArr)
}
// 获取记录用户的数据
export const getStotageUserData = storageNameKey => {
    const uid = getStore()?.getState()?.user?.currentUser?.uid

    let valueArr = storage.get(storageNameKey)
    if (Array.isArray(valueArr) && valueArr.length) {
        let itemUidObj = valueArr.find(item => item.uid === uid)
        if (itemUidObj) {
            return itemUidObj.value
        }
        return ''
    }
    return ''
}

export const setCacheByKey = key => {
    return setStotageUserData(key, '1')
}

export const getCacheByKey = key => {
    return getStotageUserData(key) === '1'
}
